
<template>

	<div class="h-100 d-flex" style="flex-direction: column;">
        <div style="height: 62px;">
            <h4>Статистические показатели ставок капитализации по объектам-аналогам</h4>
        </div>
		<div class="mt-2" style="flex: 1;" :id="this.id" v-resize v-on:resize="update" />

	</div>

</template>

<script>

import * as d3 from "d3"
import api from "../../../../../../api"

export default 
{
	props :
	{
		group_id : String,
    },
    
    data()
    {
		return {
            id : "chart_stat_capital",
			data : [],
        }
    },

    watch :
    {
		group_id :
		{
			immediate : true,

			handler(group_id)
			{
				this.group_id = group_id

				if(group_id)
					this.refresh()
			}
		},
    },

    methods :
    {
		refresh()
		{
			api.call(this, "cadastral_analogues", "get_many", { query : { "current_version.group" : this.group_id, "current_version.attrs.bad_capitalization_rate" : { "$ne" : true }, "current_version.attrs.CadastralNumber" : { "$exists" : true } } },
				response =>
				{
					var data = []

					response.data.forEach(elem => data.push(elem.current_version.attrs))

					this.data = data

					this.update()
				})
		},

        update()
        {
            const base_div = d3.select("#" + this.id)

            const width = base_div.node().offsetWidth
            const height = base_div.node().getBoundingClientRect().height - 24

            if (height <= 0)
            {
                return
            }

            const margin = { top : 24, right : 10, left : 56, bottom : 20 }
            const legend_width = 128

            if (this.svg != null)
                this.svg.remove()

            const filtered_data = this.data.filter(e => !e.bad)

            // const stat_titles = new Set(data.map(d => d.stat))
            
            const color = { 
                "Минимальное значение" : { id : "bft-blue-500", value : "var(--bft-blue-500)" },
                "Максимальное значение" : { id : "bft-cyan-500", value : "var(--bft-cyan-500)" },
                "Среднее значение" : { id : "bft-green-400", value : "var(--bft-green-400)" },
            }

            const x = d3.scaleBand()
                .domain(Object.keys(color))
                .rangeRound([margin.left, width - legend_width])
                .padding(0.5)

            const y = d3.scaleLinear()
                .domain([0, d3.max(filtered_data, d => d.capitalization_rate)]).nice()
                .rangeRound([height - margin.bottom, margin.top])

            this.svg = base_div.append("svg")
                .attr("width", width)
                .attr("height", height)
                .attr("viewBox", [0, 0, width, height])
                .attr("style", "max-width: 100%; height: auto;")

            this.svg.append("g")
                .attr("transform", `translate(${margin.left},0)`)
                .call(d3.axisLeft(y).tickSize(-(width-margin.left-legend_width)))
                .call(g => g.selectAll(".domain").remove())
            this.svg.selectAll("g.tick")
                .style("stroke-width", 0.1)
                .style("font-size", "1rem")
                .style("color", "var(--bft-neutral-400)")
                .style("font-feature-settings", "tnum")
                .style("font-variant-numeric", "tabular-nums")
                
            this.svg.append("text")
                .attr("class", "y label")
                .style("fill", "var(--bft-neutral-400)")
                .attr("dy", margin.top/2)
                .text("Ставка капитализации по объектам-аналогам")
            
            var legendTable = this.svg.append("g")
                .attr("transform", "translate(" + (width - legend_width + 24) + ", " + (height/2-36) + ")")
                .attr("class", "legendTable");

            var legend = legendTable.selectAll(".legend")
                .data(Object.keys(color))
                .enter().append("g")
                .attr("class", "legend")
                .attr("transform", function(d, i) {
                    return "translate(0, " + i * 36 + ")" 
                });
            
            legend.append("rect")
                .attr("width", 8)
                .attr("height", 16)
                .attr("rx", 4)
                .style("fill", d => color[d].value)
            
            legend.append("text")
                .attr("x", 8)
                .attr("dx", 8)
                .attr("y", 8)
                .attr("dy", ".35em")
                .attr("font-size", ".75rem")
                .style("text-anchor", "start")
                .text(d => d)
                .call(this.wrap, legend_width - 50)
            
            if (this.data.length == 0 || height == 0) 
                return

            Object.values(color).forEach((value) => this.new_gradient(this.svg, value))

            this.svg.append("g")
                .selectAll()
                .data(() => 
                    [
                        {
                            stat : "Минимальное значение",
                            value : d3.min(filtered_data, e => e.capitalization_rate)
                        },
                        {
                            stat : "Максимальное значение",
                            value : d3.max(filtered_data, e => e.capitalization_rate)
                        },
                        {
                            stat : "Среднее значение",
                            value : d3.mean(filtered_data, e => e.capitalization_rate)
                        }
                    ]
                )
                .join("rect")
                    .attr("x", d => x(d.stat))
                    .attr("y", d => y(d.value))
                    .attr("width", x.bandwidth())
                    .attr("height", d => y(0) - y(d.value))
                    .attr("fill", d => `url(#${color[d.stat].id}_${this.id})`)
                    .attr("rx", 6)
        },
        
		wrap(text, width)
		{
            text.each(function () {
                var text = d3.select(this),
                    words = text.text().split(/\s+/).reverse(),
                    word,
                    line = [],
                    lineNumber = 0,
                    lineHeight = 1.1, // ems
                    x = text.attr("x"),
                    y = text.attr("y"),
                    dy = 0, //parseFloat(text.attr("dy")),
                    tspan = text.text(null)
                                .append("tspan")
                                .attr("x", x)
                                .attr("y", y)
                                .attr("dy", dy + "em");
                
                while ((word = words.pop())) {
                    line.push(word);
                    ++lineNumber
                    tspan.text(line.join(" "));
                    if (tspan.node().getComputedTextLength() > width) {
                        line.pop();
                        tspan.text(line.join(" "));
                        line = [word];
                        tspan = text.append("tspan")
                                    .attr("x", (x * lineNumber))
                                    .attr("y", y)
                                    .attr("dy", (lineNumber-1) * lineHeight + dy + "em")
                                    .text(word);
                    }
                }
            });
        },

        new_gradient(svg, color)
        {
            const area_gradient_low = svg.append("defs").append("linearGradient")
                .attr("id", color.id + "_" + this.id)
                .attr("x1", "0%")
                .attr("x2", "0%")
                .attr("y1", "0%")
                .attr("y2", "100%")

            area_gradient_low
            .append("stop")
                .attr("offset", "0%")
                .style("stop-color", color.value)
                .style("stop-opacity", 1)

            area_gradient_low
                .append("stop")
                    .attr("offset", "100%")
                    .style("stop-color", "#ffffff")
                    .style("stop-opacity", 1)
        },
    }
}
</script>
